import { registerSW } from 'virtual:pwa-register'

import { notifier } from '../utils'

import { Strings } from '../constants'

export const updateSW = registerSW({
    onNeedRefresh: () => {

        notifier.confirm(Strings.MESSAGE_APP_UPDATE, () => updateSW(), () => {})
    },
    onOfflineReady: () => {

        notifier.success(Strings.MESSAGE_APP_INSTALLED)
    }
})